import { Link } from "react-router-dom";

function NotFound() {
    return (
        <div className="notfound-container">
        <h1>404</h1>
        <p>Oops! The page you're looking for doesn’t exist.</p>
        <Link to="/dashboard" className="home-link">Go Back Home</Link>
        </div>
    )
}

export default NotFound;